<template>
  <div>
    <overlay :show="wrapperShow" :lock-scroll="false">
      <div class="wrapper">
        <div class="box">
            <img class="updateTip" src="../../assets/img/updatetTip.png" />
            <div class="update-box">
              <img class="updateTip-wz" src="../../assets/img/updatetTip-wz.png" />
              <p>V{{tipContent.version}}</p>
            </div>
            <div class="tip">
                <h2>更新内容：</h2>
                <ul>
                  <li v-for="(item,index) in arrContent" :key="index">
                     {{item}}
                  </li>
                </ul>
            </div>
            <div class="footer-btn">
              <van-button block @click="updateNow"  type="info" loading-text="更新中...">立即更新</van-button>
            </div>
        </div>
      </div>
    </overlay>
    <overlay :show="progressShow">
      <div class="progress">
        <div class="box">
          <b style="font-size: 18px; padding: 0 12px 18px">版本更新</b>
          <van-circle
            v-model="currentRate"
            :rate="totalSize"
            :text="text"
          ></van-circle>
        </div>
      </div>
    </overlay>
  </div>
</template>
 <script>
  /**
  * 检查app版本，并提供更新
  */
  import {Overlay} from 'vant'
  import home from '@/api/common'

  export default {
  components: {
    Overlay,
  },
  props: {
    isCheck: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    text() {
      return this.totalSize == 100
        ? '更新完成，安装中'
        : '已更新' + this.totalSize.toFixed(0) + '%'
    }
  },
  mounted() {
    // this.checkVersion(true)
  },
  watch:{
    checkLoding(e){
        this.$emit('update:checkLoding',e)
    }
  },
  data() {
    return {
      checkLoding: false, // 请求loading
      wrapperShow: false,
      progressShow:false,
      currentRate: 0,
      totalSize: 0,
      tipContent:{},
      arrContent:[]
    }
  },
  methods: {
    /**
     * 检查版本
     */
    checkVersion(autoCheck = false) {
      const ua = navigator.userAgent.toLowerCase() // 设备型号
      const isApple = /iphone|ipad|ipod/.test(ua) // 苹果设备
      const isAndroid = /android/.test(ua) // 安卓设备
      let typeUa = isApple?'ios':'android';
      this.checkLoding = true
      // 检查版本
      home.uploadVision({
          //可根据打包环境制定对应环境的版本号
          appversion: isApple?process.env.VUE_APP_IOS_VERSION:process.env.VUE_APP_ANDROID_VERSION,
          type:typeUa
        })
        .then((res) => {
          this.checkLoding = false
          // 版本不一致需要更新
          if (res.code === '0') {
            if (res.data?.state) {
                !autoCheck && this.$toast('该版本为最新版本')
            } else {
                this.wrapperShow = true;
                this.tipContent = res.data;
                this.arrContent =  res.data.content && res.data.content.split('<br>');
            }
          }
        })
        .catch(() => {
          this.checkLoding = false
          // this.$toast('获取版本信息失败！')
        })
    },
    //立即更新
    updateNow(){
      // // 下载app
      this.wrapperShow = false;
      this.progressShow =true;
      if (window.plus) {
          // 在这里调用5+ API
          this.plusReady()
      } else {
          // 兼容老版本的plusready事件
          document.addEventListener(
              'plusready',
              this.plusReady,
              false
          )
      }
  },
    /**
     * 下载
     */
    plusReady() {
      const ua = navigator.userAgent.toLowerCase() // 设备型号
      const isApple = /iphone|ipad|ipod/.test(ua) // 苹果设备
      const isAndroid = /android/.test(ua) // 安卓设备
      const appUrl = isApple
        ? process.env.VUE_APP_iosDownloadUrl
        : isAndroid
        ? process.env.VUE_APP_appDownloadUrl
        : '' // 下载地址
      if (appUrl) {
        try {
          if (isApple) {
            plus.runtime.openURL(appUrl)
          } else if (isAndroid) {
            var dtask = plus.downloader.createDownload(
              appUrl,
              {},
              (d, status) => {
                if (status == 200) {
                    setTimeout(()=>{
                      this.progressShow = false
                    },1000)
                    // alert("Download success: " + d.filename);
                } else {
                  this.$toast('下载失败！' + status)
                  // alert("Download failed: " + status);
                }
              }
            )
            this.progressShow = true
              // dtask.addEventListener('statechanged', this.onStateChanged,false)
            dtask.addEventListener('statechanged',  (task, status) =>{
              switch (task.state) {
                case 1: // 开始
                  break
                case 2: //已连接到服务器
                  break
                case 3: // 已接收到数据
                  this.totalSize = parseInt(
                    (100 * task.downloadedSize) / task.totalSize
                  )
                  break
                case 4: // 下载完成  plus.notification.compProgressNotification("下载完成");//插件调用
                  plus.runtime.install(
                    plus.io.convertLocalFileSystemURL(task.filename), //安装APP
                    {
                      force: true,
                    },
                    ()=> {},
                    ()=> {
                      this.$toast('安装失败')
                    }
                  )
                  break
              }
            })
            dtask.start()
          } else {
            window.open(appUrl)
          }
        } catch {
          window.open(appUrl)
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .box {
    display: flex;
    padding-bottom: 30px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    background-color: #fff;
    border-radius: 6px;
    margin: 0 auto;
    width: calc(100% - 80px);
    .updateTip{
      width: 100%;
      border-radius: 6px;
    }
    .update-box{
       margin-top: 10px;
       position: relative;
       width: 100%;
       .updateTip-wz{
         width: 128px;
         display:block;
         margin:0 auto;
       }
       p{
        position: absolute;
        right: 30px;
        color: #1989fa;
        top:10px;
        font-size: 14px;
       }
    }
    .tip{
      padding: 10px 30px 20px 30px;
      h2{
        font-size: 15px;
        font-weight: normal;
      }
      ul{
        margin-top: 2px;
        height: 150px;
        overflow: scroll;
        li{
          font-size: 13px;
          margin-top: 5px;
        }
      }
    }
    .footer-btn{
      padding: 0 30px;
      width: 100%;
    }
  }
}
.progress{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    background-color: #fff;
    border-radius: 6px;
    padding: 12px;
    width: 60%;
  }
}
</style>

